import PropTypes from 'prop-types';
import React from 'react';
import { CancelOrderButton } from '../../../../../../../atomic/buttons/cancelOrderButton/CancelOrderButton';
import { Body4 } from '../../../../../../../atomic/text/Text';
import { colors } from '../../../../../../../../colorVars';
import { modifySoftOrderProvideDetails } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifySoftOrders';
import ApplyRounding from '../../../../../../../../utils/math/ApplyRounding';
import style from './MiniOrdersTable.module.css';

// a TastyTrade "pending target" (or any reactive, watched-not-resting level) rendered as a row in
// the same table as real broker orders. There is no broker order behind this yet - it only becomes
// one once a trade print touches the target - so unlike MiniOrderTableRow, qty/price aren't
// editable here (the backend has no "modify a pending target" capability yet, only cancel) and the
// row is visually marked as pending via the orange side label and italic price.
export const PendingTargetTableRow = ({
  completeSoftOrder,
  cancelKey,
  cancelKeyType,
  qty,
  price,
  sideLabel,
}) => {
  const handleCancel = () => {
    modifySoftOrderProvideDetails({
      softOrder: completeSoftOrder,
      details: {
        cancelPendingTarget: {
          ...(cancelKeyType === 'price' ? { price: cancelKey } : { level: cancelKey }),
          pluginId: completeSoftOrder?.value?.tacticId,
        },
      },
    });
  };

  return (
    <tr>
      <td>
        <div className={style.cancelButtonWrapper}>
          <CancelOrderButton clickHandler={handleCancel} width={15} />
        </div>
      </td>
      <td>
        <Body4 color={colors.orange}>{sideLabel}</Body4>
      </td>
      <td>
        <Body4 color={colors.lightGrey}>{qty}</Body4>
      </td>
      <td>
        <span style={{ fontStyle: 'italic' }}>
          <Body4 color={colors.lightGrey}>{ApplyRounding(price, 2)}</Body4>
        </span>
      </td>
    </tr>
  );
};

PendingTargetTableRow.propTypes = {
  completeSoftOrder: PropTypes.object.isRequired,
  cancelKey: PropTypes.number.isRequired,
  cancelKeyType: PropTypes.oneOf(['level', 'price']).isRequired,
  qty: PropTypes.number,
  price: PropTypes.number.isRequired,
  sideLabel: PropTypes.string.isRequired,
};
